import _ from 'lodash';

export class ApplicationChangeApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getApplicationChangesHistory({ applicationId, skipForbiddenError, ...body }) {
    // Loan-editor secondary read: a subtree-scoped TPO broker is not authorized for pending/log
    // changes history, so a 403 here must degrade the panel, not toast (DEV-4226).
    return this.#http.post(`/application/${applicationId}/changes/history`, body, {
      ...(skipForbiddenError && { skipResponseInterceptor: { forbiddenError: true } }),
    });
  }

  async saveApplicationChanges({
    applicationId,
    loanCompletionDelayInHours,
    saveWithoutProgram,
    withLoanOptionId,
    ...body
  }) {
    return this.#http.put(`/application/${applicationId}/changes/save/v2`, body, {
      params: {
        loanCompletionDelayInHours,
        saveWithoutProgram,
        withLoanOptionId,
      },
    });
  }

  async cancelApplicationChanges({ applicationId, authors = null }) {
    if (_.isNil(authors)) {
      return this.#http.put(`/application/${applicationId}/changes/cancel/v2`);
    }

    return this.#http.put(`/application/${applicationId}/changes/cancel/v2`, { authors });
  }
}
